import { apiClient } from './client';

export const startEdutechAssessment = async () => {
  const response = await apiClient.post('/edutech/start');
  return response.data;
};

export const getEdutechQuestions = async (attemptId) => {
  const response = await apiClient.get('/edutech/questions', {
    params: { attemptId }
  });
  return response.data;
};

export const submitEdutechAssessment = async (attemptId, answers, proctoringData, profilePhoto) => {
  if (!attemptId) {
    throw new Error('attemptId is required for submission');
  }
  const response = await apiClient.post('/edutech/submit', {
    attemptId,
    answers,
    proctoringData,
    profilePhoto
  });
  return response.data;
};

export const getEdutechResult = async (attemptId) => {
  const response = await apiClient.get(`/edutech/result/${attemptId}`);
  return response.data;
};
